import PropTypes from 'prop-types';

const mostCommonPositionPropType = PropTypes.shape({
  id: PropTypes.string,
  code: PropTypes.string,
  name: PropTypes.string,
  generalPosition: PropTypes.string,
});

const playerPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  gamesRostered: PropTypes.number,
  mostCommonNumber: PropTypes.string,
  mostCommonPosition: mostCommonPositionPropType,
});

const competitionPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  level: PropTypes.string,
});

const seasonPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
});

const teamPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  shortName: PropTypes.string,
  colorPrimary: PropTypes.string,
  colorSecondary: PropTypes.string,
  colorTertiary: PropTypes.string,
  gameCount: PropTypes.number,
});

const NavigationDataPropType = PropTypes.shape({
  players: PropTypes.arrayOf(playerPropType),
  competitions: PropTypes.arrayOf(competitionPropType),
  seasons: PropTypes.arrayOf(seasonPropType),
  teams: PropTypes.arrayOf(teamPropType),
});

export { NavigationDataPropType };

const nodePropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  date: PropTypes.string,
  phaseName: PropTypes.string,
  roundShortName: PropTypes.string,
  homeScore: PropTypes.number,
  awayScore: PropTypes.number,
  dataComplete: PropTypes.bool,
  shortName: PropTypes.string,
  homeTeam: teamPropType,
  awayTeam: teamPropType,
});

const gamesEdgesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    node: nodePropType,
  }),
);

const GamesDataPropType = PropTypes.shape({
  edges: gamesEdgesPropType,
});

export { GamesDataPropType };
